import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20elegant%20abstract%20background%20with%20subtle%20geometric%20patterns%20in%20warm%20copper%20and%20charcoal%20tones%2C%20sophisticated%20minimalist%20design%20with%20soft%20gradient%20lighting%2C%20professional%20and%20serene%20atmosphere%2C%20no%20text%20or%20figures%2C%20clean%20modern%20aesthetic&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="十八禁合规指引平台背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 mb-4 tracking-tight">
          十八禁内容合规指引平台
        </h1>
        <p className="text-base md:text-lg text-background-200/90 max-w-2xl mb-8 leading-relaxed">
          为成年用户提供全面、专业的合规访问指引、内容分级说明及安全使用建议。
          深入了解法律边界与平台规范，确保在合法合规前提下安全浏览。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/falv-fagui"
            className="px-6 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-medium transition-all duration-200 hover:bg-primary-600 whitespace-nowrap cursor-pointer"
          >
            开始了解
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 border border-background-50/30 text-background-50 rounded-lg text-sm font-medium transition-all duration-200 hover:bg-background-50/10 whitespace-nowrap cursor-pointer"
          >
            关于我们
          </Link>
        </div>
        <div className="mt-10 flex items-center gap-6">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold font-heading text-background-50">
              50+
            </p>
            <p className="text-xs md:text-sm text-background-300">深度研究文章</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold font-heading text-background-50">
              5
            </p>
            <p className="text-xs md:text-sm text-background-300">内容分类板块</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold font-heading text-background-50">
              10万+
            </p>
            <p className="text-xs md:text-sm text-background-300">月访问用户</p>
          </div>
        </div>
      </div>
    </section>
  );
}